import Button from "@material-ui/core/Button";
import Drawer from "@material-ui/core/Drawer";
import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";
import deleteIcon from "Assets/newicons/action/delete-bin/outline/delete-bin-outline-16px.svg";
import designationIcon from "Assets/newicons/attribute/designation/outline/designation-outline-16px.svg";
import classNames from "classnames";
import { DatePickerComponent } from "Component/Custom";
import DynamicForm from "Component/DynamicForm";
import { integerinputconverter } from "Component/DynamicForm/Fields/Integer";
import { multiselectinputconverter } from "Component/DynamicForm/Fields/MultiSelect";
import { selectinputconverter } from "Component/DynamicForm/Fields/Select";
import { textinputconverter } from "Component/DynamicForm/Fields/Text";
import { textareainputconverter } from "Component/DynamicForm/Fields/Textarea";
import DrawerHeader from "Component/Headers/drawerHeader";
import LabelIcon from "Component/Labels/LabelIcon";
import moment from "moment";
import { withSnackbar } from "notistack";
import React from "react";
import { connect } from "react-redux";
import { getEJ2CalenderDateFormat } from "Utils";
import { isIndateBeforeOutdate } from "Utils/dates";

const styles = () => ({
  drawerPaper: {
    width: "30%",
    padding: 16,
  },
});

const jobstype = [
  {
    displayvalue: 1,
    displayname: "New hire",
  },
  {
    displayvalue: 2,
    displayname: "Replacement",
  },
];

class AddRequisition extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      permissions: { editable: true, readonly: true },
      flag: false,
      requisitionTitle: "",
      description: "",
      jobs: [],
      jobTypeId: "",
      positionCount: "",
      arremployeedata: [],
      hiredate: "",
      locations: [],
      locationId: "",
      employmentTypeId: "",
      employmenttypes: [],
      employeeId: "",
      employees: [],
      priorityId: "",
      priorities: [],
      allemployees: [],
      requistionsList: [],
      createmenu: false,
      create_anchorEl: null,
      rating: 4,
      startDate: "",
      endDate: "",
      hiringPipelines: [],
      pipelineId: "",
    };
    this.handleChange = this.handleChange.bind(this);
    this.dateOnSelect = this.dateOnSelect.bind(this);
  }

  handleChange(key, value) {
    this.setState({ [key]: value });
  }

  dateOnSelect(event) {
    const startDate = event.startdate;
    const endDate = event.enddate;
    const isvalid = isIndateBeforeOutdate({
      indate: moment(),
      outdate: moment(startDate, "YYYY-MM-DD"),
    });
    if (isvalid) {
      const val = { startDate, endDate };
      this.setState({ selectedDate: val, ...val }, () => {
        this.GetWorkRequest(startDate);
      });
    } else {
      if (startDate && endDate) {
        this.props.enqueueSnackbar("Can not select today or past dates", {
          variant: "error",
        });
      }
      this.setState({ selectedDate: null });
    }
  }

  SelectHireDate(args) {
    const date = this.ConvertDate(args.value);
    const hiredate = date;
    this.setState({ hiredate });
  }

  componentDidMount() {}

  componentWillUnmount() {}

  render() {
    const { classes } = this.props;
    const { drawerOpen } = this.state;
    return (
      <div>
        <Grid container>
          <Grid item xs={12} md={12} sm={12}>
            <div style={{ width: 350 }}>
              <DynamicForm
                fields={textinputconverter({
                  value: this.state.requisitionTitle,
                  label: "Title of requisition",
                  placeholder: "Enter title",
                })}
                onChange={(e) => this.handleChange("requisitionTitle", e)}
              />

              <DynamicForm
                fields={textareainputconverter({
                  value: this.state.description,
                  label: "Requisition description",
                  placeholder: "Enter title",
                })}
                onChange={(e) => this.handleChange("description", e)}
              />
              <p className="normal-dark-secondary margin-bottom-8">Job list</p>
              <div
                className="rounded-rectangle-div margin-bottom-16"
                style={{ width: 230 }}
              >
                <span className="floatleft">
                  <LabelIcon label="Head count stats" img={designationIcon} />
                  <LabelIcon label="employee namee" img={designationIcon} />
                </span>
                <span className="floatright">
                  <img src={deleteIcon}></img>
                  <p className="extra-small-dark-secondary">3 positions</p>
                </span>
                <div className="clear-float"></div>
              </div>
              <Button
                className="btn btn-secondary-md-blue"
                variant="contained"
                onClick={() => this.setState({ drawerOpen: true })}
              >
                Add job
              </Button>
            </div>
          </Grid>
        </Grid>
        <Drawer
          anchor="right"
          open={this.state.drawerOpen}
          onClose={() =>
            this.setState({
              drawerOpen: false,
            })
          }
          classes={{
            paper: classNames(classes.drawerPaper, "planner-drawer"),
          }}
        >
          <DrawerHeader
            header="Add job"
            isbackarrow={false}
            closeDrawer={() =>
              this.setState({
                drawerOpen: false,
              })
            }
          />

          <DynamicForm
            fields={selectinputconverter({
              value: this.state.jobId,
              placeholder: "",
              label: "Select job",
              options: this.state.jobs,
            })}
            onChange={(selectedid) => {
              this.handleChange("jobId", selectedid);
            }}
          />
          <DynamicForm
            fields={selectinputconverter({
              value: this.state.jobTypeId,
              placeholder: "",
              label: "New hire or replacement?",
              options: jobstype,
            })}
            onChange={(selectedid) => {
              this.handleChange("jobTypeId", selectedid);
            }}
          />
          {this.state.jobTypeId == 1 && (
            <div>
              <DynamicForm
                fields={integerinputconverter({
                  value: this.state.positionCount,
                  placeholder: "",
                  label: "How many positions are available?",
                  min: 1,
                })}
                onChange={(value) => {
                  this.handleChange(value, "positionCount");
                }}
              />
            </div>
          )}
          {this.state.jobTypeId == 2 && (
            <div>
              <DynamicForm
                fields={multiselectinputconverter({
                  value: this.state.employeeids,
                  label: "Select outgoing employee(s)",
                  placeholder: "",
                  options: this.state.allemployees,
                })}
                onChange={(ids) => {
                  this.handleChange("employeeids", ids);
                }}
              />
              <p className="extra-small-dark-secondary">
                3 positions will be shown as available
              </p>
            </div>
          )}

          <div>
            <p className="input-label">Hire by date</p>
            <DatePickerComponent
              placeholder="Select Date"
              id="startDate"
              allowEdit
              format={getEJ2CalenderDateFormat()}
              value={this.state.hiredate}
              min={this.state.minApplyDate}
              change={this.SelectHireDate.bind(this)}
            />
          </div>
          <div className="margin-top-16">
            <DynamicForm
              fields={selectinputconverter({
                value: this.state.locationId,
                placeholder: "",
                label: "Reporting location",
                options: this.state.locations,
              })}
              onChange={(selectedid) => {
                this.handleChange("locationId", selectedid);
              }}
            />
          </div>
          <DynamicForm
            fields={selectinputconverter({
              value: this.state.employmentTypeId,
              placeholder: "",
              label: "Employment type",
              options: this.state.employmenttypes,
            })}
            onChange={(selectedid) => {
              this.handleChange("employmentTypeId", selectedid);
            }}
          />

          <DynamicForm
            fields={selectinputconverter({
              value: this.state.priorityId,
              placeholder: "",
              label: "Priority",
              options: this.state.priorities,
            })}
            onChange={(selectedid) => {
              this.handleChange("priorityId", selectedid);
            }}
          />
          <DynamicForm
            fields={selectinputconverter({
              value: this.state.pipelineId,
              placeholder: "",
              label: "Hiring manager",
              options: this.state.hiringPipelines,
            })}
            onChange={(selectedid) => {
              this.handleChange("pipelineId", selectedid);
            }}
          />

          <Button
            className="btn btn-primary-md-blue"
            variant="contained"
            onClick={() => this.setState({ drawerOpen: true })}
          >
            Add job
          </Button>
        </Drawer>
      </div>
    );
  }
}
const mapStateToProps = () => ({});

export default connect(mapStateToProps)(
  withStyles(styles, { withTheme: true })(withSnackbar(AddRequisition)),
);
